import { render, staticRenderFns } from "./ProductListPage.vue?vue&type=template&id=28bed55b"
import script from "./ProductListPage.vue?vue&type=script&lang=js"
export * from "./ProductListPage.vue?vue&type=script&lang=js"
import style0 from "./ProductListPage.vue?vue&type=style&index=0&id=28bed55b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports